module.exports = __webpack_public_path__ + "img/16.4f3f9482.jpg";